import { CreateLabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { VerticalLayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/layout/VerticalLayout";
import { BetData, LabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { SimpleTextPaytableComponentComponentPayload } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/SimpleTextPaytableComponent";
import { TextFromContainer } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utils";
import { convertDisplayObjectToImage } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utilsImg";
import { GameServices } from "game/GameServices";
import { Container, Text } from "pixi.js";


export type TargetsComponentPayload = {
    title: LabelText
    content: LabelText
    table: [LabelText, LabelText][]
    positions: {
        multiplierStyle: string,
        multiplierLeft: string[],
        multiplierRight: string[],
        sprite: string
    }
}

export class TargetsComponent extends BasePaytableComponent {
    private readonly tableContainer: Container;
    private readonly postitionsContainer: Container;
    private readonly layout: VerticalLayout;
    private readonly titleTextfield: Text;
    private readonly contentTextfield: Text;


    constructor(protected override services: GameServices, payload: TargetsComponentPayload, createLabelText: CreateLabelText, name?: string) {
        super(services);
        const { table, positions } = payload;

        this.layout = new VerticalLayout({ gap: 10 });

        this.titleTextfield = createLabelText(payload.title, 0.5, 0);
        this.layout.add(this.titleTextfield);

        this.contentTextfield = createLabelText(payload.content, 0.5, 0);
        this.layout.add(this.contentTextfield);

        this.tableContainer = this.createTable(table, createLabelText);
        this.layout.add(this.tableContainer);

        this.postitionsContainer = this.createPositions(services, positions, createLabelText);
        this.layout.add(this.postitionsContainer);

        this.layout.layout(this);
    }

    private createTable(table: [LabelText, LabelText][], createLabelText: CreateLabelText) {
        const x = 3;
        let y = 0;
        const container = new Container();
        for (const [key, val] of table) {
            const keyText = createLabelText(key, 1, 0.5);
            const valText = createLabelText(val, 0, 0.5);
            keyText.y = y;
            valText.y = y;
            keyText.x = -x;
            valText.x = x;
            y += Math.max(keyText.height, valText.height);
            container.addChild(keyText);
            container.addChild(valText);
        }
        this.addChild(container);
        return container;
    }

    private createPositions(services: GameServices, positions: { multiplierStyle: string; multiplierLeft: string[]; multiplierRight: string[]; sprite: string; }, createLabelText: CreateLabelText) {
        const container = new Container();
        const x = 75;
        const gap = 9;
        const posInit = -2;
        let y = posInit;

        services.factory.createSpriteFromTextureKey(positions.sprite, { anchor: { x: 0.5, y: 0.2 } }, container);
        for (const posStr of positions.multiplierLeft) {
            const pos = createLabelText({ label: posStr, style: positions.multiplierStyle }, 1, 0.5);
            container.addChild(pos);
            pos.x = -x;
            pos.y = y;
            y += pos.height + gap;
        }
        y = posInit;
        for (const posStr of positions.multiplierRight) {
            const pos = createLabelText({ label: posStr, style: positions.multiplierStyle }, 0, 0.5);
            container.addChild(pos);
            pos.y = y;
            pos.x = x;
            y += pos.height + gap;
        }

        this.addChild(container);
        return container;
    }

    onOpen(betData: BetData) { }
    updateLayout(width: number, height: number) {
        this.postitionsContainer.width = width;
        if (this.postitionsContainer.scale.x > 1) this.postitionsContainer.scale.x = 1;
        this.postitionsContainer.scale.y = this.postitionsContainer.scale.x;
        this.layout.layout(this);
    }

    /**
     * Return Pixi container as HTML friendly Text content.
     * Used for search functionality
     */
    async getRenderedContentAsText(): Promise<ReadonlyArray<TextFromContainer>> {

        const images = [];
        const symbols = await convertDisplayObjectToImage(this.services.application.renderer, this.tableContainer, `image/png`);
        images.push(symbols);
        const icons = await convertDisplayObjectToImage(this.services.application.renderer, this.postitionsContainer, `image/png`);
        images.push(icons);

        const container: TextFromContainer = { title: this.titleTextfield.text, content: this.contentTextfield.text, images };

        return [container];
    }
}
